import { h } from '@atomify/jsx';
import { Col } from '@atoms/col/col';

interface RowInterface {
    extraClass?: string;
    children?: NodeList;
}

export const Row = ({ extraClass = '', children }: RowInterface) => (
    <div class={`o-grid ${extraClass}`}>{children}</div>
);

interface SingleColumnRowInterface extends RowInterface {
    cols?: (number | undefined)[];
}

export const SingleColumnRow = ({ extraClass = '', cols, children }: SingleColumnRowInterface) => (
    <Row extraClass={extraClass}>
        <Col cols={cols}>{children}</Col>
    </Row>
);
